import { configureStore } from '@reduxjs/toolkit';
import products from 'slices/products';
import cart from 'slices/cart';
import token from 'slices/token';
import categories from 'slices/categories';
import auth from 'slices/auth';
import { loadFromLocalStorage, saveToLocalStorage } from './init';

const store = configureStore({
   reducer: {
      products,
      cart,
      token,
      categories,
      auth
   },
   preloadedState: loadFromLocalStorage()
});

store.subscribe(() => saveToLocalStorage(store.getState()));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
